import { render, staticRenderFns } from "./ReportsEdit.vue?vue&type=template&id=2008b924&scoped=true&"
import script from "./ReportsEdit.vue?vue&type=script&lang=js&"
export * from "./ReportsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2008b924",
  null
  
)

export default component.exports